import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fix-padding" }
const _hoisted_2 = { class: "d-flex justify-space-between align-center" }
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = { class: "ms-2" }
const _hoisted_5 = { class: "text-large" }
const _hoisted_6 = { class: "text-small" }
const _hoisted_7 = { class: "info-content" }
const _hoisted_8 = ["innerHTML"]

import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Infor from '../../../api/v2/models/information'
import api from '../../../api/v2/api'
import { headerState } from '../../stores/header'
import { footerState } from '../../stores/footer'
import ButtonBack from '../atoms_molecules/ButtonBack.vue'
import { format } from 'date-fns'
import { ROUTER_NAME } from '../../router'
import { snackBarState } from '../../stores/snackbar'
import { SnackBar } from '../../models/other_models'

// Router

export default /*@__PURE__*/_defineComponent({
  __name: 'InforDetail',
  setup(__props) {

const route = useRoute()
const router = useRouter()

// Reactive state
const infor = ref<Infor | null>(null)
const breadcrumbs = ref([
  {
    text: 'クラスルーム',
    disabled: false,
    exact: true,
    to: '/classroom/'
  },
  {
    text: 'お知らせ一覧',
    disabled: false,
    exact: true,
    to: '/classroom/infors'
  }
])

// Computed properties
const breadcrumbItems = computed(() => {
  return breadcrumbs.value.map(b => ({
    text: b.text,
    to: b.disabled ? undefined : b.to
  }))
})

// Methods
const dateFormat = (date: Date) => {
  return format(date, 'YYYY/MM/DD HH:mm')
}

const unread = async () => {
  if (infor.value) {
    await api.infor.unread(infor.value.id.toString())
    router.push({
      name: ROUTER_NAME.INFOR_LIST
    })
  }
}

const back = () => {
  router.push({
    name: ROUTER_NAME.INFOR_LIST
  })
}

// Lifecycle
onMounted(() => {
  headerState.setTitle('お知らせ')
  footerState.setFooterDefault()
  api.infor.show(route.params.inforId as string).then((res) => {
    infor.value = res
    breadcrumbs.value.push({
      text: infor.value.title,
      disabled: true,
      exact: true,
      to: ''
    })
  }).catch((err) => {
    snackBarState.snackbar = new SnackBar(true, 'このページは非公開です', err.apiStatus)
    router.push({
      name: ROUTER_NAME.INFOR_LIST
    })
  })
})

return (_ctx: any,_cache: any) => {
  const _component_AppBreadcrumb = _resolveComponent("AppBreadcrumb")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (breadcrumbItems.value && breadcrumbItems.value.length)
      ? (_openBlock(), _createBlock(_component_AppBreadcrumb, {
          key: 0,
          items: breadcrumbItems.value
        }, null, 8 /* PROPS */, ["items"]))
      : _createCommentVNode("v-if", true),
    (infor.value)
      ? (_openBlock(), _createBlock(_component_v_col, {
          key: 1,
          lg: "12",
          class: "pt-3 bg-white"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(ButtonBack, { onClick: back }),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(infor.value.title), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(dateFormat(infor.value.createdAt)), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", {
                  class: "text-small ms-2 border-default p-1 text-blue cursor-pointer",
                  onClick: unread
                }, " 未読に戻す ")
              ])
            ]),
            _createVNode(_component_v_divider),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", {
                class: "my-3 html-body",
                innerHTML: infor.value.content
              }, null, 8 /* PROPS */, _hoisted_8)
            ])
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})